import React from 'react';
import DimensionTable from './DimensionTable';
import DimensionDropdown from './DimensionDropdown';
import { DimensionTableWrapper } from './styled';
import { tid } from '@utils/test';

function DimensionTableWidget({ dimension, widgetIndex, dimensionIndex, unit }) {
  return (
    <DimensionTableWrapper {...tid(`dimension-table::${dimension}`)}>
      <DimensionDropdown
        dimension={dimension}
        widgetIndex={widgetIndex}
        dimensionIndex={dimensionIndex}
      />
      <DimensionTable dimension={dimension} unit={unit} />
    </DimensionTableWrapper>
  );
}

export default DimensionTableWidget;
